import styled from 'styled-components';
import { Button } from '../Buttons/ButtonV2/index.js';

const Container = styled.div.withConfig({
    displayName: "styles__Container",
    componentId: "sc-135a2cb1-0"
})`
    display: grid;
    gap: ${({ theme  })=>theme.spacers.L};
`;
const Row = styled.div.withConfig({
    displayName: "styles__Row",
    componentId: "sc-135a2cb1-1"
})`
    display: flex;
    align-items: center;
    column-gap: ${({ theme  })=>theme.spacers.M};
`;
const Title = styled.h2.withConfig({
    displayName: "styles__Title",
    componentId: "sc-135a2cb1-2"
})`
    ${({ theme  })=>theme.typography.SuperTinyHeadline};
    color: ${({ theme  })=>theme.colors.Foreground};
    padding-bottom: ${({ theme , thin  })=>thin ? "0" : theme.spacers.M};
    padding-right: ${({ theme  })=>theme.spacers.XL};
`;
const Paragraph = styled.p.withConfig({
    displayName: "styles__Paragraph",
    componentId: "sc-135a2cb1-3"
})`
    ${({ theme  })=>theme.typography.Paragraph};
    color: ${({ theme  })=>theme.colors["Level 5"]};
`;
const EmojiRow = styled(Row).withConfig({
    displayName: "styles__EmojiRow",
    componentId: "sc-135a2cb1-4"
})`
    justify-content: space-between;
`;
const LabelRow = styled(Row).withConfig({
    displayName: "styles__LabelRow",
    componentId: "sc-135a2cb1-5"
})`
    justify-content: space-between;
    margin-top: ${({ theme  })=>theme.spacers.S};
`;
const EmojiIcon = styled.div.withConfig({
    displayName: "styles__EmojiIcon",
    componentId: "sc-135a2cb1-6"
})`
    width: 48px;
    height: 48px;
    cursor: pointer;
    border-radius: 24px;

    display: flex;
    align-items: center;
    justify-content: center;

    background-color: ${({ theme  })=>theme.colors["Level 1"]};

    &:hover {
        background-color: ${({ theme  })=>theme.colors["Level 2"]};
    }
`;
const TextArea = styled.textarea.withConfig({
    displayName: "styles__TextArea",
    componentId: "sc-135a2cb1-7"
})`
    ${({ theme  })=>theme.typography.Paragraph};

    width: 100%;
    resize: none;
    box-sizing: border-box;
    padding: ${({ theme  })=>theme.spacers.M};
    border-radius: ${({ theme  })=>theme.spacers.S};
    color: ${({ theme  })=>theme.colors["Level 5"]};
    background-color: ${({ theme  })=>theme.colors.ElementBackground};
    border: 1px solid ${({ theme  })=>theme.colors["Level 1"]};

    &:focus {
        outline: transparent;
    }
`;
const PrimaryButton = styled(Button).withConfig({
    displayName: "styles__PrimaryButton",
    componentId: "sc-135a2cb1-8"
})``;

export { Container, EmojiIcon, EmojiRow, LabelRow, Paragraph, PrimaryButton, Row, TextArea, Title };
